<script lang="ts" setup>
import { VueFinalModal } from 'vue-final-modal'
import AppModalSeatWidgetLtdContent from '~/components/AppModalSeatWidgetLtdContent.vue'

const modals = useModalsStore()

</script>

<template>
  <VueFinalModal
    v-model="modals.isSeatWidgetLtdModalOpen"
    class="app-modal-seat-widget-ltd-content"
    content-class="app-modal-seat-widget-ltd-content"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <AppModalSeatWidgetLtdContent></AppModalSeatWidgetLtdContent>
  </VueFinalModal>
</template>
